import { Button } from "@material-ui/core";
import React from "react";
import { goTo } from "../../Helpers/history";
import { Routes } from '../Router/routes';

export const LoginButton = () => (
    <Button color="inherit" onMouseUp={_ => goTo(Routes.Pages.Login)} size="small">
        Вход
    </Button>
);